import * as clientActions from 'actions/client';

const initialState = {
  alertTitle: '',
  alertDescription: '',
  showAlert: false,
  requestScroll: false,
  targetScrollPosition: 0,
  lastUsedDepositDetails: null,
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientActions.SHOW_ALERT:
      return { ...state, ...action.payload };
    case clientActions.HIDE_ALERT:
      return { ...state, ...action.payload };
    case clientActions.CONTENT_SCROLLED:
      return { ...state, ...action.payload };
    case clientActions.SCROLL_CONTENT:
      return { ...state, ...action.payload };
    case clientActions.SET_LAST_USED_DEPOSIT_DETAILS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default clientReducer;



// WEBPACK FOOTER //
// ./src/reducers/client/index.js